import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LoginModalComponent } from "../features/layouts/login-modal/login-modal.component";

/**
 * Opens the shared login modal from outside the layout (e.g. route guards) and
 * sends the user on to their intended destination once they authenticate.
 */
@Injectable({ providedIn: "root" })
export class LoginModalService {
  private bsModalService = inject(BsModalService);
  private router = inject(Router);
  private modalRef?: BsModalRef<LoginModalComponent>;

  /**
   * Shows the login modal. On a successful login the user is navigated to
   * `redirectTo` (when provided). No-ops if the modal is already open.
   */
  open(redirectTo?: string): void {
    if (this.modalRef) {
      return;
    }

    // reload=false: we navigate here instead of doing a full page reload so the
    // user lands on the page they originally requested.
    this.modalRef = this.bsModalService.show(LoginModalComponent, {
      initialState: { reload: false },
    });

    this.modalRef.content?.loginSuccess.subscribe(() => {
      if (redirectTo) {
        this.router.navigateByUrl(redirectTo);
      }
      this.modalRef?.hide();
    });

    this.modalRef.onHidden?.subscribe(() => {
      this.modalRef = undefined;
    });
  }
}
